import { cn } from "@/lib/utils";

/** Marca (ícone) do BaitaTicket — mesma geometria do favicon/ícone do PWA. */
export function LogoMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={cn("shrink-0", className)}
      role="img"
      aria-label="BaitaTicket"
    >
      <rect x="4" y="4" width="92" height="92" rx="22" fill="#3E74F5" />
      <rect x="20" y="36" width="42" height="28" rx="6" fill="#FFFFFF" />
      <rect x="66" y="36" width="14" height="28" rx="4" fill="#FFFFFF" />
    </svg>
  );
}

/**
 * Logo completa (ícone + wordmark). O texto herda a cor do tema (claro/escuro) automaticamente.
 * Use `onDark` quando o logo ficar sobre um fundo escuro fixo nos dois temas (ex.: sidebar):
 * a parte "Ticket" passa a usar o branco da sidebar em vez da cor de texto do tema.
 */
export function Logo({
  size = 28,
  textClassName = "text-xl",
  className,
  iconOnly = false,
  onDark = false,
}: {
  size?: number;
  textClassName?: string;
  className?: string;
  iconOnly?: boolean;
  onDark?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <LogoMark size={size} />
      {!iconOnly && (
        <span className={cn("font-bold whitespace-nowrap", textClassName)}>
          <span className="text-primary">Baita</span>
          <span className={cn(onDark && "text-sidebar-accent-foreground")}>Ticket</span>
        </span>
      )}
    </div>
  );
}
